import { render, staticRenderFns } from "./tagCard.vue?vue&type=template&id=ab9b0b0e&scoped=true"
import script from "./tagCard.vue?vue&type=script&lang=js"
export * from "./tagCard.vue?vue&type=script&lang=js"
import style0 from "./tagCard.vue?vue&type=style&index=0&id=ab9b0b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_5hxyaa5b57h6kqtn5hqvbk3bcu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b0b0e",
  null
  
)

export default component.exports